import { useEffect, useRef } from 'react';

// Keyboard-wedge scanners type into the dedicated barcode field. Human search stays manual.
export const useScanInput = (setValue, onScan) => {
  const timer = useRef(null);
  const burst = useRef({ at: 0, count: 0, length: 0 });
  const callback = useRef(onScan);
  callback.current = onScan;
  useEffect(() => () => clearTimeout(timer.current), []);
  const cancel = () => { clearTimeout(timer.current); burst.current = { at: 0, count: 0, length: 0 }; };
  const change = raw => {
    clearTimeout(timer.current); setValue(raw);
    const now = performance.now(), previous = burst.current;
    const count = now - previous.at < 60 ? previous.count + 1 : 1;
    const pasted = raw.length - previous.length >= 8;
    burst.current = { at: now, count, length: raw.length };
    if (/^\d{8,14}$/.test(raw) && (count >= 6 || pasted)) {
      timer.current = setTimeout(() => { cancel(); callback.current(raw); }, 150);
    }
  };
  return { change, cancel };
};